const PaymentTypeMapping = {
    Check: {
        label: 'Check',
        value: 'Check',
    },
    MoneyOrder: {
        label: 'Money Order',
        value: 'CheckRequest',
    },
    ElectronicTransfer: {
        label: 'Electronic Transfer',
        value: 'EFT',
    },
};

export default PaymentTypeMapping;
